import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    root: {
        paddingLeft: 15,
        paddingRight: 15,
        marginTop: 20,
        cursor: 'pointer'
    },
    main: {
        height: "100%",
        backgroundColor: "#2f3243",
        zIndex: 1,
        border: "1px solid #2e344e",
        borderTop: "5px solid #2e344e",
        padding: theme.spacing(8),
        // alignItems: 'center',
        transition: ".4s",
        '&:hover': {
            borderTopColor: theme.palette.primary.main,
            transition: ".4s"
        }
    },

    title: {
        marginTop: 15,
        position: 'relative',
        paddingBottom: 15,
        "&::before": {
            content: "''",
            position: 'absolute',
            left: 0,
            top: 'auto',
            bottom: 0,
            height: 2,
            width: 50,
            background: ' #2e344e',
        }
    },
    desc: {
        marginTop: 15
    }
}))

export default function Service({ title, desc, icon, onClickProp }) {
    const classes = useStyles()
    return (
        <Grid
            onClick={onClickProp}
            item lg={4} md={6} xs={12} className={classes.root} >
            <Grid className={classes.main} container direction='column' alignItems="flex-start" >
                {icon}
                <Typography className={classes.title} variant="h6">{title}</Typography>
                <Typography className={classes.desc} variant="subtitle2">
                    {desc}
                </Typography>
            </Grid>
        </Grid>
    )
}
